import React from 'react'
import NavbarComponent from './navbar.component'
import AboutBannerComponent from './aboutbanner.component'

function GalleryComponent() {
  return (
    <div>
        <div className='art-banner'>
            <div className='home' id='Home'>
                <NavbarComponent />

                <div className='innerpage-banner'>
            <div className={`container mainComponentCenter d-flex flex-column justify-content-center align-items-center  mt-lg-0`} >
            <h1 className='text-light nav-item-main-head '> MEHANDI GALLERY</h1>
        </div>
        </div>
            </div>
        </div>
    </div>
  )
}

export default GalleryComponent